/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines the competition structure - how winners are determined
 * @export
 */
export const ChallengeType = {
    RAFFLE: 'RAFFLE',
    LEADERBOARD: 'LEADERBOARD',
    GUILD: 'GUILD',
    TEAM: 'TEAM',
    HEAD_TO_HEAD: 'HEAD_TO_HEAD'
} as const;
export type ChallengeType = typeof ChallengeType[keyof typeof ChallengeType];


export function instanceOfChallengeType(value: any): boolean {
    for (const key in ChallengeType) {
        if (Object.prototype.hasOwnProperty.call(ChallengeType, key)) {
            if (ChallengeType[key as keyof typeof ChallengeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChallengeTypeFromJSON(json: any): ChallengeType {
    return ChallengeTypeFromJSONTyped(json, false);
}

export function ChallengeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeType {
    return json as ChallengeType;
}

export function ChallengeTypeToJSON(value?: ChallengeType | null): any {
    return value as any;
}

export function ChallengeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ChallengeType {
    return value as ChallengeType;
}

